import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IdrCurrencyPipe } from './idr-currency.pipe';
import { HyphenPipe } from './hyphen.pipe.service';
import { CountdownPipe } from './countdown.pipe';
import { DateTimePipe } from './datetime.pipe';
import { SafePipe } from './safe.pipe';
import { RemoveTagPipe } from './remove-tag.pipe';
import { DatesPipe } from './dates.pipe';
import { MathPipe } from './math.pipe';
import { SearchfilterPipe } from './searchfilter.pipe';

@NgModule({
  declarations: [
    SearchfilterPipe,
    CountdownPipe,
    IdrCurrencyPipe,
    HyphenPipe,
    DateTimePipe,
    SafePipe,
    RemoveTagPipe,
    DatesPipe,
    MathPipe,
  ],
  exports: [
    SearchfilterPipe,
    CountdownPipe,
    IdrCurrencyPipe,
    HyphenPipe,
    DateTimePipe,
    SafePipe,
    RemoveTagPipe,
    DatesPipe,
    MathPipe,
  ],
  imports: [CommonModule],
  providers: [IdrCurrencyPipe, HyphenPipe, MathPipe],
})
export class PipesModule {}
